<template>
  <v-container :style="PowerpointPage.bgstyle">
  <v-row>
    <div v-if="!isMobile()">
      <v-col cols="12" class="my-0 py-0">
        <h1 style="font-size: 8vh;">{{PowerpointPage.title}}</h1>
      </v-col>
    </div>
    <div v-else>
      <v-col cols="12" v-if="PowerpointPage.id == 0">
        <h1 style="font-size: 5vh;">{{PowerpointPage.title}}</h1>
      </v-col>
      <v-col cols="12" class="ma-0 pa-0" v-else>
        <h1 style="font-size: 4vh;" class="ma-0 pa-0">{{PowerpointPage.title}}</h1>
      </v-col>
    </div>
    <v-col cols="12" lg="12" v-if="PowerpointPage.subtitle" class="my-0 py-0">
      <b style="font-size: 3vh;">{{ PowerpointPage.subtitle }}</b>
    </v-col>
    <v-col cols="12" lg="12" v-for="point in PowerpointPage.points" :key="point.id" 
      :style="point ? '' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
      <p style="font-size: 3vh; margin: 0; position: absolute; top: 20vh; right: 55vh; width: 40vh;" 
        :style="PowerpointPage.style">{{ point }}</p>
    </v-col>
    <v-col cols="12" lg="12" v-for="bullet in PowerpointPage.bullets" :key="bullet.id" :style="bullet ? 'margin: 0px; padding: 0px; margin-left:10px;' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
      <p  style="font-size: 3vh; margin: 0; padding: 0; text-align: left;" :style="PowerpointPage.style"> {{ bullet }}</p>
    </v-col>
    <v-col cols="12" lg="12" v-for="text in PowerpointPage.small" :key="text.id" :style="text ? '' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
      <p  style="font-size: 2.5vh; margin: 0; text-align: left;"> <b style="font-size: 2.7vh;">{{ text.title }}</b> {{ text.text }}</p>
    </v-col>

    <v-col cols="12" lg="12" style="padding: 4px;" v-for="formline in PowerpointPage.form" :key="formline.id" :style="formline ? '' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
      <p  style="font-size: 2.2vh; margin: 0; padding:0; text-align: left;"> <b style="font-size: 2.3vh;">{{ formline.title }}</b> {{ formline.text }}</p>
    </v-col>

    <v-col cols="12" lg="12" v-for="link in PowerpointPage.linkstag" :key="link.id" :style="link ? '' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
      <a :href="link" style="font-size: 3vh; margin: 0; text-align: left;" target="_blank"> {{ link }}</a>
    </v-col>

    <v-col cols="6" lg="6" v-for="link in PowerpointPage.links" :key="link.id" :style="link ? '' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
      <!-- <a style="font-size: 4vh; margin: 0;">{{ link.link }}</a> -->
      <iframe v-if="!isMobile()" width="100%" height="270px" style="display: block; margin-left: auto; margin-right: auto;"
        :src="link.link" title="YouTube video player" frameborder="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <iframe v-else width="100%" height="120px"
        :src="link.link" title="YouTube video player" frameborder="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <b style="font-size: 3vh; margin: 0;"> {{ link.name }}</b>
    </v-col>
    <v-col cols="12" lg="12" align-self="center" justify="center" v-if="PowerpointPage.img">
      <v-img
        :src="require('@/' + PowerpointPage.img)"
        style="object-fit: scale-down; max-height: 60vh; max-width: 50vw; display: block; margin-left: auto; margin-right: auto;"
      ></v-img>
    </v-col>
    <!-- <v-col >
      <image-scroll :Scroll="PowerpointPage.scroll" :Title="PowerpointPage.title" />
    </v-col> -->
    <!-- {{this.pagenr }} / {{ this.TotalPages }} -->

    <v-col v-if="pagenr+1 != TotalPages" cols="12" lg="4" style="position: absolute; bottom: 40vh; left: 15vw; width: 20vw; height: 20vh; justify-content: left; align-items: left; text-align: left;">
      <v-row v-for="button in PowerpointPage.buttons" :key="button.id">
        <!-- <v-btn dark large color="#7d533c" class="white--text pa-5 mx-auto my-2" @click="hskChoose(1)" 
          elevation="5" style="filter: drop-shadow(0px 0px 0px #000);">
          {{ button }}
        </v-btn> -->
        <v-btn rounded large color="#ffc973" elevation="5" class="ma-4 white--text pa-5 mx-auto" style="text-align: left;" @click="hskChoose(1)">
          {{ button }}</v-btn>
      </v-row>
    </v-col>
    <v-card v-else class="pa-5" style="position: fixed; width: 30vw; max-height: 40vh; left:25vw; bottom: 30vh; background-color: #90E1F0;"
      variant="outlined">
      <v-card-item>
        <div>
          <!-- <div class="text-overline mb-1">
            OVERLINE
          </div> -->
          <div class="text-h6 mb-1">
            <p style="font-size: 3vh;">Dit onderdeel is klaar</p>
          </div>
          <div class="text-caption"><p style="font-size: 2vh;">Goed dat je het hebt afgemaakt!</p></div>
        </div>
      </v-card-item>
      <v-card-actions>
        <!-- <v-btn dark fab large color="#7d533c" class="ma-2 white--text pa-5 mx-auto" to="/"
          elevation="5" style="filter: drop-shadow(0px 0px 0px #000);">
          Home
        </v-btn> -->
        <v-btn to="/" rounded large color="#ff9d00" elevation="5" class="ma-2 white--text pa-5 mx-auto"><v-icon large>mdi-home</v-icon>Klaar!</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <router-link to="/" class="white--text">Home</router-link> -->

  </v-row>
</v-container>
</template>

<script>
// import ImageScroll from '@/components/ImageScroll.vue'  
import store from '@/store'

export default {
  name: 'PowerPointButton',
  components:{
    // ImageScroll
  },
  props: {
      PowerpointPage: Object,
      TotalPages: Number,
  },
  computed: {
    pagenr () {
      return store.state.page
    },
    answer(){
      return store.state.answer
    }
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    hskChoose(hskLevel) {
      store.commit("PAGE", hskLevel);
    }
  }
}
</script>

<style>

</style>